
class ProtoDirective {

    constructor(meister, config) {
        this.config = config; // this is htmlUI config!
        this.meister = meister;
    }

    unload() {

    }

}

export default ProtoDirective;



// WEBPACK FOOTER //
// ./src/js/directives/ProtoDirective.js